import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Policyquote from '../views/policy-quote.vue'
import compareplan from '../views/compare-plan.vue'
import policydetails from '../views/policy-details.vue'
import checkout from '../views/checkout.vue'
import proposal from '../views/proposal.vue'
import proposaldetailscheck from '../views/proposaldetailscheck.vue'
import proposaldetailscheckdiy from '../views/proposaldetailscheckdiy.vue'
import thankYouReject from'../views/thankyourejectdiy.vue'
import thankYouhdfc from'../views/thankyoupageRM.vue'
import docsubmitted from'../views/doc-submitted.vue'
import dashboard from'../views/dashboard.vue'
import payment from'../views/payment.vue'
import uploaddocument from '../views/upload-doc.vue'
import uploaddocumentdiy from '../views/upload-doc-diy.vue'
import termplanqte from '../views/termplanqte.vue'
import thankYoumail from'../views/thankyoumail.vue'
import thankYoumailDIY from'../views/thankyoumaildiy.vue'
import alertpage from '../views/alertpage.vue'
import alertdiy from '../views/alert-diy.vue'
import networkalert from '../views/networkalert.vue'
import login from '../views/login.vue'
const routes = [
  {
    path: '/login',
    name: 'loginpage  ',
    component: login
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/dashboard',
    name: 'dashbord',
    component: dashboard
  },
  {
    path: '/policy-quote',
    name: 'policyquote',
    component: Policyquote
  },
  {
    path: '/compareplan',
    name: 'compareplan',
    component: compareplan
  },
  {
    path: '/policydetails',
    name: 'policydetails',
    component: policydetails
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: checkout
  },
  {
    path: '/proposal',
    name: 'proposal',
    component: proposal
  },
  {
    path: '/payment',
    name: 'paymnt',
    component: payment
  },
  {
    path: '/proposaldetailscheck',
    name: 'proposaldetailscheck',
    component: proposaldetailscheck
  },
  {
    path: '/thankYou',
    name: 'thankYouReject',
    component: thankYouReject
  },
  
  {
    path: '/thankyoupage',
    name: 'thankYouPage',
    component: thankYouhdfc
  },
  {
    path: '/docsubmitted',
    name: 'docsubmitted',
    component: docsubmitted
  },
  {
    path: '/thankyoumail',
    name: 'thankYouMail',
    component: thankYoumail
  },
  {
    path: '/thankyoumaildiy',
    name: 'thankYouMailDIY',
    component: thankYoumailDIY
  },
  {
    path: '/alert',
    name: 'alertpage',
    component: alertpage
  },
  {
    path: '/networkalert',
    name: 'networkalert',
    component: networkalert
  },
  {
    path: '/alert-diy',
    name: 'alertdiy',
    component: alertdiy
  },
  {
    path: '/proposaldetailscheckdiy',
    name: 'proposaldetailscheckdiy',
    component: proposaldetailscheckdiy
  },
  {
    path: '/upload-doc',
    name: 'uploaddoc',
    component: uploaddocument
  },
  {
    path: '/upload-doc-diy',
    name: 'uploaddocdiy',
    component: uploaddocumentdiy
  },
  {
    path: '/termplanqte',
    name: 'term-plan-qte',
    component: termplanqte
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) { 
    // always scroll to top
    return { top: 0 }
  }
})
export default router

// const router = createRouter({
//   history: createWebHistory(),
//   routes
// })
// export default router

// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes
// })
// export default router
